import React from 'react';
import PropTypes from 'prop-types';
import './database_list.scss';
import DatabaseRow from './database_row';

const DatabaseList = ({ newCorporateDatabaseUrl, databases = [] }) => {
  const databaseRows = [];
  databases.forEach((db) => {
    databaseRows.push(
      <DatabaseRow
        editPath={db.edit_path}
        key={db.id}
        name={db.name}
      />
    );
  });

  const createNewDB = () => {
    window.open(newCorporateDatabaseUrl, '_blank');
  };

  return (
    <div className="database-list">
      <div className="database-list__new-db">
        <button className="database-list__new-db-button" onClick={createNewDB}>
          Create New Database
        </button>
      </div>
      <div className="database-list__header-row">
        <div className="database-list__header-icon">
          <span className="fas fa-shield-alt" />
        </div>
        <div className="database-list__header-text">Database Manager</div>
      </div>
      <div className="database-list__description">
        You are able to manage the databases listed below. As a manager, you can maintain privacy while interacting seamlessly with your colleagues throughout the suite of Buildout products, export your data at any time, and take your data with you wherever you go.
      </div>
      <div className="database-list__items">
        { databaseRows }
      </div>
    </div>
  );
};

DatabaseList.propTypes = {
  databases: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      backoffice: PropTypes.bool,
      edit_path: PropTypes.string.isRequired
    })
  ).isRequired,
  newCorporateDatabaseUrl: PropTypes.string.isRequired
};

export default DatabaseList;
